// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  transactions: null,
  transaction_types: [
    // 'tra_01',
    'tra_02',
    'tra_03',
    'tra_04',
    // 'tra_05',
    'tra_06',
    'tra_07',
    'tra_08',
    'tra_09',
    'tra_10',
  ],
  options: {},
  search: '',
  balance_options: {},
  balance_search: '',
  last_date: null,
  last_transaction_type_id: null,
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },
  search (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/transaction/search', payload)
        .then(result => {
          state.transactions = result.data
          resolve(result.data)
        }).catch(error => {
          reject(error)
      })
    })
  },
  balance_list (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/transaction/balance-list', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  fetch (context, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload)
      axios.get('/api/transaction/' + payload.id).then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  update (context, payload) {
    state.last_date = payload.date
    state.last_transaction_type_id = payload.transaction_type_id
    return new Promise((resolve, reject) => {
      axios.patch('/api/transaction', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  insert (context, payload) {
    state.last_date = payload.date
    state.last_transaction_type_id = payload.transaction_type_id
    return new Promise((resolve, reject) => {
      axios.put('/api/transaction', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  delete (context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/transaction/' + payload.id, payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  reCalculate (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/transaction/re-calculate', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  send_mail_balance (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/send-mail/balance', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
